import { render, staticRenderFns } from "./ConfigurazioniContabilitaPage.vue?vue&type=template&id=4a9f2b16"
import script from "./ConfigurazioniContabilitaPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioniContabilitaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports